import { render } from "./ProvidersPage.vue?vue&type=template&id=ad779fac&ts=true"
import script from "./ProvidersPage.vue?vue&type=script&lang=ts"
export * from "./ProvidersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__